<template>
    <BorrarModalComponent
        :name="'borrar-' + puerta_id"
        title="¿Seguro que quieres borrar esta puerta?"
        confirmButton="¿BORRAR PUERTA?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarPuerta()"
    />
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['puerta_id', 'evento_id'],
        methods: {
            close(borrado) {
                this.$emit('close', 'borrar-' + this.puerta_id, borrado);
            },
            borrarPuerta() {
                const params = {
                    filters : {},
                    puerta_id: this.puerta_id,
                    evento_id: this.evento_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.puertas.borrar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.close(true);
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
